import styled from 'styled-components';

interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function InProgressIcon(props: Props) {
  const { size = 22, className } = props;

  return (
    <SpinningSvg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="progressbar"
    >
      <path
        opacity="0.3"
        d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        opacity="0.9"
        d="M21 11C21 5.47715 16.5228 1 11 1"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SpinningSvg>
  );
}

const SpinningSvg = styled.svg`
  animation: rotate 1.2s linear infinite;

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`;
